import {objectTypeToMatSymbol} from './material-icons';

export const BROKEN_THUMBNAIL_ICON = 'broken_image';
export const NOT_READY_THUMBNAIL_ICON = 'hourglass';
// Polling of one media for its conversion ends after this; the last status stays and a reload checks again
export const MAX_CONVERSION_POLL_MS = 2 * 60 * 60 * 1000;

// Attachments and 3D models often have no preview at all, so when their thumbnail cannot be
// loaded they show the symbol of their media type. Everything else (images, video poster frames,
// the image of an object) should have a preview, so a thumbnail that fails to load is broken.
// Keys are lower case because object_type casing varies; values are the type names the symbol lookup knows.
const PREVIEW_OPTIONAL_TYPES: Record<string, string> = {
  attachment: 'Attachment',
  attachmentitem: 'AttachmentItem',
  model3d: 'Model3D',
  model3ditem: 'Model3DItem',
};

export function thumbnailFallbackIcon(objectType: string): string {
  const knownType = PREVIEW_OPTIONAL_TYPES[objectType?.toLowerCase()];
  return (knownType && objectTypeToMatSymbol(knownType)) || BROKEN_THUMBNAIL_ICON;
}

// DMS statuses of media that is still being uploaded or converted, whose preview may not exist yet
const NOT_READY_STATUSES = ['init', 'convert', 'converting'];
// DMS statuses after which a missing preview will not appear anymore
const FINISHED_STATUSES = ['done', 'fail'];

export function isMediaNotReady(dmsStatus: string): boolean {
  return NOT_READY_STATUSES.includes(dmsStatus);
}

// For media whose conversion status is looked up when its thumbnail fails. The thumbnail only
// counts as broken once the status says the conversion has finished; until then the media type
// symbol is shown, and the hourglass while the media is still converting.
export function mediaThumbnailFallbackIcon(objectType: string, dmsStatus: string): string {
  if (isMediaNotReady(dmsStatus)) {
    return NOT_READY_THUMBNAIL_ICON;
  }
  if (FINISHED_STATUSES.includes(dmsStatus)) {
    return thumbnailFallbackIcon(objectType);
  }
  return objectTypeToMatSymbol(objectType) ?? BROKEN_THUMBNAIL_ICON;
}
